import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import AccordionItem from './AccordionItem';

const StyledAccordion = styled.div`
  margin: 0 auto 60px auto;
  max-width: ${p => p.theme.globalWidthXSmall};

  ${breakpoints.medium`
    margin: 0 auto 80px auto;
  `};

  ${breakpoints.large`
    margin: 0 auto 140px auto;
  `};
`;

const Title = styled.h2`
  margin-bottom: 25px;

  ${breakpoints.medium`
    margin-bottom: 40px;
  `};

  ${breakpoints.large`
    margin-bottom: 48px;
  `};
`;

const Content = styled.div``;

export default function Accordion({ title, items }) {
  const accordionList = items.map(({ heading, content }, index) => (
    <AccordionItem
      key={`${heading}-${index}`}
      heading={heading}
      content={content}
    />
  ));

  return (
    <StyledAccordion>
      <Title>{title}</Title>

      <Content>{accordionList}</Content>
    </StyledAccordion>
  );
}

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired
};
